<div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
    <app-user-roles-list [user]="user" [roles]="roles" [adminRightsCurrentUser]="adminRightsCurrentUser"
        [righsEditable]="righsEditable" (updateUserInRole)="updateRoles($event)"></app-user-roles-list>
</div>